import { InputTextarea } from "primereact/inputtextarea";

type IncidentDetailsFieldProps = {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

const IncidentDetailsField: React.FC<IncidentDetailsFieldProps> = (props) => {
  return (
    <div className="device-setting-group">
      <b>Zusätzliche Informationen</b>
      <p>
        Beschreiben Sie hier das Szenario, z.B. "Überfall" oder "Medizinischer
        Notfall".
      </p>
      <InputTextarea
        id="incidentDetails"
        value={props.value}
        onChange={props.onChange}
        className="p-my-2"
        placeholder="z.B. Der Betrieb ABC wird überfallen. Bitte nutzen Sie den Seiteneingang."
        rows={5}
        cols={50}
        autoResize
      />
    </div>
  );
};

export default IncidentDetailsField;
